import { AiOutlineClose as CloseIcon } from 'react-icons/ai';
import { Modal } from "react-bootstrap";
import styles from './WelcomeModal.module.scss';
import WelcomeImg from '../../../assets/images/welcomeDashboard.png';
import pinningChat from '../../../assets/images/pinningChat.gif';
import addWorkspace from '../../../assets/images/addWorkspace.gif';
import AddMember from '../../../assets/images/addMember2.gif';

import agencyDashboardImg from '../../../assets/images/agency/agencyDashboard.png'
import agency1 from '../../../assets/images/agency/agency1v1.mp4';
import agency2 from '../../../assets/images/agency/agency2v1.mp4';
import agency3 from '../../../assets/images/agency/agency3v1.mp4';

import userDashboardImg from '../../../assets/images/dashboard/dashboardTutorial.png';
import user1 from '../../../assets/images/user/user1.mp4';
import user2 from '../../../assets/images/user/user2.mp4';
import user3 from '../../../assets/images/user/user3.mp4';

import { useEffect, useRef, useState } from 'react';
import { getLocalUser } from '../../functions/utilities';


type Props = {
    modalVisible: boolean;
    onClose: () => void;
}


const WelcomeModal = ({ onClose, modalVisible }: Props) => {
    const [step, setStep] = useState(0);
    const [tutorial, setTutorial] = useState([]);
    let user = getLocalUser()
    const videoRef = useRef(null);

    useEffect(() => {

        const welcomeSteps = user?.role == "Agency" ?
            [
                {
                    title: `Welcome to Merito, ${user.name.split(" ")[0]}!`,
                    subTitle: "Merito is an actionable data hub where you can aggregate data from all your customer engagements in one place.\n Invite your customers and set up Merito in just 5 minutes!",
                    image: agencyDashboardImg

                },
                {
                    title: "Invite your Customers",
                    subTitle: "Your customers need to set up a Merito account and add Workspaces to that account, in just 5 minutes as well!",
                    image: agency1
                },
                {
                    title: "Manage Multiple Customers",
                    subTitle: "Go inside a Workspace and view data for various customers. You can also action on their data to show them how you’re hitting their goals.",
                    image: agency2
                },
                {
                    title: "Build a Custom Dashboard",
                    subTitle: "Pin important metrics from various Workspaces to build a customised dashboard that has comparative snapshots of different customers’ data.",
                    image: agency3
                }
            ]
            : [
                {
                    title: `Welcome to Merito, ${user.name.split(" ")[0]}!`,
                    subTitle: "Merito sends you a fully customised report with metrics from all your daily tools!.<br/> Set up your company's account in just 5 minutes following these 3 easy steps!",
                    image: userDashboardImg
                },
                {
                    title: "Add a Workspace",
                    subTitle: "Workspaces are readymade Merito dashboards for all your everyday applications",
                    image: user1
                },
                {
                    title: "Build a Custom Dashboard",
                    subTitle: "Pin charts from any Workspace to your personal Merito dashboard and get a customised report",
                    image: user2
                },
                {
                    title: "Add your Team",
                    subTitle: "Invite your colleagues to your Merito account and then give them access to specific Workspaces",
                    image: user3
                }
            ]

        setTutorial(welcomeSteps);
    }, [])



    useEffect(() => {
        if (videoRef?.current) {
            videoRef?.current?.load()
        }
    }, [step]);


    if (tutorial.length == 0) {
        return <></>
    }

    return (
        <Modal show={modalVisible} onHide={onClose} centered size='lg'>
            <div className={styles.dialogMain}>
                <div className={styles.headerBtnContainer}>
                    <div className={styles.closeBtn} onClick={onClose}>
                        <CloseIcon />
                    </div>
                </div>
                <div className={styles.body}>
                    <div className={styles.title}>
                        {tutorial[step]?.title}
                    </div>

                    <div className={styles.info} dangerouslySetInnerHTML={{ __html: tutorial[step]?.subTitle }}>
                    </div>

                    {/* <div className={styles.imgContainer}> */}
                    {step == 0 ?

                        <img className={user?.role == "Agency" ? `${styles.imgMargin}` : 'p-3'} style={{ borderRadius: "4px", border: "1px solid #808080" }} src={tutorial[step]?.image} alt="" key={tutorial[step]?.image} />
                        :
                        <video className={step == 1 ? styles.addMargin : ''} style={{ border: "1px solid #808080", borderRadius: "4px" }} ref={videoRef} muted={true} autoPlay={true} loop={true}>
                            <source src={tutorial[step]?.image} type="video/mp4" />
                        </video>}
                    {/* </div> */}

                    {step == 0 ?
                        <div className={styles.btnContainer}>
                            <button className={`${styles.getStartedBtn}`} onClick={() => {
                                setStep(step + 1)
                            }}>
                                <div className={styles.buttonText}>
                                    Get Started
                                </div>
                            </button>
                        </div> :
                        <div className={styles.btnFooter}>
                            <button className={`${styles.prevBtn}`} onClick={() => setStep(step - 1)}>
                                <div className={styles.buttonText}>
                                    Previous
                                </div>
                            </button>
                            <button className={`${styles.getStartedBtn}`} onClick={() => {
                                if (step == (tutorial.length - 1)) {
                                    onClose()
                                } else {
                                    setStep(step + 1);
                                }
                            }}>
                                <div className={styles.buttonText}>
                                    {step == (tutorial.length - 1) ? "Close" : "Next"}
                                </div>
                            </button>
                        </div>
                    }
                </div>
            </div>
        </Modal>
    );
}

export default WelcomeModal;